'use client';

import { useQuery } from '@tanstack/react-query';
import { getProductById, type ProductWithCategories } from '@/lib/api/products';
import { ProductPhoto, usePhotoEdges } from './offer-product';
import { getOfferPhoto } from './offer-photo-source';
import './offer-catalog-photo.css';

/** The same gift query as the conditions dialog; admin replacements stay authoritative. */
export function useOfferGift(id: number | undefined) {
  return useQuery({
    queryKey: ['promotion-gift', id],
    queryFn: () => getProductById(id!, true),
    enabled: id !== undefined && Number.isInteger(id) && id > 0,
    staleTime: 60_000,
    retry: false,
  });
}

/** The same approved product scene is shown in the feed and its conditions dialog. */
export function OfferCatalogPhoto({
  product,
  loading = false,
  className = '',
  eager = false,
}: {
  product?: ProductWithCategories;
  loading?: boolean;
  className?: string;
  eager?: boolean;
}) {
  const photo = getOfferPhoto(product);
  const scene = usePhotoEdges(photo);
  return (
    <div
      className={`offer-catalog-photo ${className}`}
      style={scene}
      data-catalog-product-id={product?.id}
    >
      {product && photo ? (
        <ProductPhoto
          key={`${product.id}:${photo}`}
          src={photo}
          name={product.name}
          optimized
          eager={eager}
        />
      ) : (
        <span className="offer-catalog-photo-message" role={loading ? 'status' : undefined}>
          {loading ? 'Загружаем подарок…' : 'Фото подарка временно недоступно'}
        </span>
      )}
    </div>
  );
}
